import { SLOTS } from './slots.js'

// Colleges scoped to a college town (area). Primary links to the edit page.
export default {
  key: 'college',
  label: 'College',
  icon: 'colleges',
  columns: [
    { slot: SLOTS.CONTEXT, field: 'area.name', label: 'College Town', areaScoped: true, link: 'area.url' },
    { slot: SLOTS.PRIMARY, field: 'name', link: 'url' },
    { slot: SLOTS.METADATA, field: 'address', label: 'Address' },
    { slot: SLOTS.METADATA, field: 'logo_url', label: 'Logo', renderer: 'media_thumb', alt: 'Logo' }
  ],
  empty: { icon: 'colleges', message: 'No colleges yet.' },
  defaultView: 'table',
  compact: { show: [SLOTS.PRIMARY, SLOTS.CONTEXT] }
}
